import React from 'react';
import { ResourceModule } from '../../features/common/ResourceModule';
import { registerForms } from '../../features/common/formRegistry';
import { animalMovementsApi } from '../../services/resources';
import { formatDate, today } from '../../utils/format';
import type { AnimalMovement } from '../../types';
import type { ModuleConfig } from '../../features/common/types';

const config: ModuleConfig<AnimalMovement> = {
  title: 'Animal Movement',
  subtitle: 'Record when an animal is moved between locations on the farm.',
  entityLabel: 'movement',
  module: 'Movement',
  queryKey: 'animal-movements',
  api: animalMovementsApi,
  idKey: 'id',
  referenceKeys: ['animals', 'locations'],
  addLabel: 'Record Movement',
  searchPlaceholder: 'Search movements…',
  defaultValues: { movement_date: today() },
  columns: [
    { key: 'date', header: 'Date', primary: true, render: (r) => formatDate(r.movement_date) },
    { key: 'from', header: 'From Location', render: (r) => r.from_location_id ?? '—' },
    { key: 'to', header: 'To Location', render: (r) => r.to_location_id },
    { key: 'reason', header: 'Reason', render: (r) => r.reason ?? '—' },
  ],
  fields: [
    { name: 'animal_id', label: 'Animal', type: 'select', section: 'Movement Details', required: true, optionsKey: 'animals' },
    { name: 'movement_date', label: 'Movement Date', type: 'date', section: 'Movement Details', required: true },
    { name: 'from_location_id', label: 'From Location', type: 'select', section: 'Movement Details', optional: true, optionsKey: 'locations' },
    { name: 'to_location_id', label: 'To Location', type: 'select', section: 'Movement Details', required: true, optionsKey: 'locations' },
    { name: 'reason', label: 'Reason', type: 'text', section: 'Movement Details', optional: true, fullWidth: true, placeholder: 'e.g. Moved to quarantine shed' },
  ],
};

export default function AnimalMovementPage() {
  return <ResourceModule config={config} />;
}

// For Administration -> Entry Form Settings.
registerForms('Animals', config);
